import {
  CloudAccount,
  CloudAccountInput,
  ClusterAccount,
  ClusterInput,
} from './cloudAccount';
import { User } from './user';

export type ProjectRole = 'Owner' | 'UserAdmin' | 'Reader';
export type EntraGroupsMap = Record<string, string>;
export type EntraGroupsCollection = EntraGroupsMap | EntraGroupsMap[];

export interface Project {
  id: string;
  ancestorId: string;
  name: string;
  description: string;
  businessUnit: string;
  projectRole?: ProjectRole;
  ussRoles?: Record<string, string> | Array<Record<string, string>>;
  projectOwners: User[];
  cloudAccountLinks: CloudAccount[];
  identifiers: string[];
  entraGroupIds?: string[];
  entraGroups?: EntraGroupsCollection;
  lastAccessReviewAt: string;
  lastAccessReviewBy: string;
  assignedUsersList: User[];
  isFolder: boolean;
  hasChildren: boolean;
  ancestorProjects?: Project[];
  kubernetesClusters: ClusterAccount[];
  isReader?: boolean;
}

export class ProjectInput {
  id?: string;
  name!: string;
  description?: string;
  businessUnit?: string;
  projectOwners?: string[];
  cloudAccountLinks?: CloudAccountInput[];
  identifiers?: string[];
  isFolder: boolean | undefined;
  parentProjectId?: string;
  kubernetesClusterSetLinks?: ClusterInput[];
}

export interface Cluster {
  id: string;
  externalId: string;
  name: string;
  cloudAccount?: {};
}
